// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .el-table__footer .el-table__cell {\n  background-color: #F3B792;\n}\n.el-table .warning-row {\n  background: oldlace;\n}\n", ""]);
// Exports
module.exports = exports;
